import { Component, EventEmitter, Output } from '@angular/core';
import { ErrorService, SplittypayError } from '../../core/error.service';
import { ERROR_UNPAID_NOT_FOUND } from '../../shared/constants/operationals';
import { ListUnpaidParams, Unpaid, UnpaidService } from '../../core/unpaid.service';

@Component({
  selector: 'app-unpaid-data',
  templateUrl: './unpaid-data.component.html',
  styleUrls: ['./unpaid-data.component.scss'],
})
export class UnpaidDataComponent {
  @Output() refresh: EventEmitter<void> = new EventEmitter<void>();
  is_list_running: boolean = true;
  is_load_more_running: boolean = true;
  unpaid?: Unpaid[];
  cursor: string | null = null;
  total?: number;
  filters?: ListUnpaidParams;

  constructor(private unpaidService: UnpaidService, private error_service: ErrorService) {}

  ngOnInit(): void {
    this.unpaid = [];
    this.cursor = null;
    this.total = undefined;
    this.filters = undefined;
    this.listUnpaid();
  }

  onRefresh(): void {
    this.unpaid = [];
    this.cursor = null;
    this.filters = undefined;
    this.total = undefined;
    this.listUnpaid();
  }

  onFilter(filters?: ListUnpaidParams): void {
    this.unpaid = [];
    this.cursor = null;
    this.total = undefined;
    this.filters = filters;
    this.listUnpaid(filters);
  }

  onScrollEnd(): void {
    if (this.cursor && !this.is_load_more_running) this.onLoadMoreClick();
  }

  onLoadMoreClick(): void {
    this.listUnpaid(this.filters, true);
  }

  listUnpaid(filters?: ListUnpaidParams, is_load_more_running?: boolean): void {
    this.is_list_running = !is_load_more_running;
    this.is_load_more_running = is_load_more_running || false;

    const list_params = {
      ...filters,
      cursor: this.cursor,
    };

    this.unpaidService.listUnpaid(list_params).subscribe({
      next: response => {
        const unpaid = response.data.data;
        this.unpaid = (this.unpaid ? this.unpaid : []).concat(unpaid);
        this.cursor = response.data.cursor;
        if (list_params.cursor == undefined) {
          this.total = response.data.total.value;
        }

        this.is_list_running = false;
        this.is_load_more_running = false;
      },
      error: error => {
        const processed_error: SplittypayError = this.error_service.preProcessApiError(error);
        if (processed_error.code == ERROR_UNPAID_NOT_FOUND) {
          this.unpaid = [];
        } else {
          this.error_service.processApiError(processed_error.code, processed_error.message);
        }
        this.is_list_running = false;
        this.is_load_more_running = false;
      },
    });
  }
}
